__turbopack_context__.v({
  "assetCountCell": "FolderRow-module__5ZiPaq__assetCountCell",
  "childRow": "FolderRow-module__5ZiPaq__childRow",
});
